import {
  Button,
  CheckboxField,
  ChevronDownIcon,
  List,
  Popover,
} from '@iheartjane/reefer';
import { useMemo } from 'react';

import type { StaffMember } from '@jane/business-admin/types';
import { ROLE_LABEL_MAPPING } from '@jane/business-admin/util';

export const StaffFilterRole = ({
  onChange,
  staffMembers = [],
  value,
}: {
  onChange: (value: string[]) => void;
  staffMembers?: StaffMember[];
  value: string[];
}) => {
  const availableRoles = useMemo(
    () =>
      staffMembers.length
        ? Array.from(
            staffMembers.reduce<Set<string>>((roles, staffMember) => {
              roles.add(staffMember.role);
              return roles;
            }, new Set())
          )
        : Object.keys(ROLE_LABEL_MAPPING),
    [staffMembers]
  );
  const handleChange = (role: string, selected: boolean) => {
    const roles = new Set(value);

    if (selected) {
      roles.add(role);
    } else {
      roles.delete(role);
    }

    onChange(Array.from(roles));
  };

  const label = 'Role';

  return (
    <Popover
      label={label}
      target={
        <Button
          label={label}
          variant="tertiary"
          endIcon={<ChevronDownIcon size="sm" />}
        />
      }
    >
      <Popover.Content label={label}>
        <List label="staff-roles" style={{ width: '270px' }}>
          {availableRoles.map((role) => {
            const label = (ROLE_LABEL_MAPPING as { [key: string]: string })[
              role
            ];
            return (
              <List.Item key={`role-item-${role}`}>
                <CheckboxField
                  label={label}
                  name={`filter-${label.replace(/\s+/, '_')}`}
                  onChange={(checked) => handleChange(role, checked)}
                  defaultChecked={value.includes(role)}
                />
              </List.Item>
            );
          })}
        </List>
      </Popover.Content>
    </Popover>
  );
};
